import { useDesignTokens } from "@boi/react-design-tokens";

import {
  getScrollShadowKeyframes,
  getScrollShadowMixin,
} from "./ScrollShadow.styled";

export function useScrollShadowMixin() {
  const { tokens } = useDesignTokens();
  const { scrollShadowContainer } = tokens;

  const scrollShadowMixin = getScrollShadowMixin(
    getScrollShadowKeyframes(scrollShadowContainer.shadow.color)
  );

  return scrollShadowMixin;
}
